<div class="people">
    <img src="../../../../assets/img/people/{{tiles.image}}" alt="people" class="people-image">
    <div class="people-text">
        <h5>{{tiles.title}}</h5>
        <h6>{{tiles.description}}</h6>
    </div>
</div>
